import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#0c4a6e] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/lovable-uploads/0fd941b6-b554-4fc9-b411-7af95f1e529c.png" 
                alt="Gavinsurance Logo" 
                className="h-10 md:h-12"
              />
            </div>
            <p className="text-white/80 mb-6">
              Ofrecemos soluciones de seguros personalizadas para proteger lo que más valoras, respaldados por las mejores aseguradoras del mercado.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-6">Seguros</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors inline-block">
                  Seguro de Vida
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors inline-block">
                  Seguro de Salud
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors inline-block">
                  Seguro Dental
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors inline-block">
                  Seguro de Visión
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors inline-block">
                  Seguro Suplementario
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-6">Compañía</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-white/80 hover:text-white transition-colors inline-block">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-white transition-colors inline-block">
                  Contacto
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-6">Contáctanos</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 text-[#33C3F0] mt-0.5" />
                <span className="text-white/80">
                  7500 NW 25 ST #237<br />
                  Doral, FL 33122
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-3 text-[#33C3F0]" />
                <a href="tel:+17865695142" className="text-white/80 hover:text-white transition-colors">
                  (888) 370-8454
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-3 text-[#33C3F0]" />
                <a 
                  href="mailto:info@gavinsurance.com" 
                  className="text-white/80 hover:text-white transition-colors"
                >
                  info@gavinsurance.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm mb-4 md:mb-0">
            © {currentYear} gavinsurance. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacidad" className="text-sm text-white/60 hover:text-white transition-colors">
              Privacidad
            </Link>
            <Link to="/terminos" className="text-sm text-white/60 hover:text-white transition-colors">
              Términos
            </Link>
            <Link to="/cookies" className="text-sm text-white/60 hover:text-white transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
